export default __webpack_public_path__ + "static/media/Ocelots_Still_4.12277ad8.jpg";